import { render, staticRenderFns } from "./WriteOffSmallBal.vue?vue&type=template&id=2d16477b&"
import script from "./WriteOffSmallBal.vue?vue&type=script&lang=js&"
export * from "./WriteOffSmallBal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports